import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

import WarrantyPortal from "./pages/public/WarrantyPortal";
import WarrantyClaimForm from "./pages/public/WarrantyClaimForm";
import WarrantyTrack from "./pages/public/WarrantyTrack";

import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import ClaimsList from "./pages/admin/ClaimsList";
import RmaCase from "./pages/admin/RmaCase";
import VendorClaims from "./pages/admin/VendorClaims";
import ReadyToShip from "./pages/admin/ReadyToShip";
import ShippingSlip from "./pages/admin/ShippingSlip";
import Replacements from "./pages/admin/Replacements";
import ReplacementReport from "./pages/admin/ReplacementReport";
import CreditNotes from "./pages/admin/CreditNotes";
import Customers from "./pages/admin/Customers";
import Suppliers from "./pages/admin/Suppliers";
import SubInventory from "./pages/admin/SubInventory";
import Reports from "./pages/admin/Reports";
import Settings from "./pages/admin/Settings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/warranty" replace />} />
            <Route path="/warranty" element={<WarrantyPortal />} />
            <Route path="/warranty/claim" element={<WarrantyClaimForm />} />
            <Route path="/warranty/track" element={<WarrantyTrack />} />

            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<Navigate to="/admin/warranty" replace />} />
            <Route path="/admin/warranty" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin/warranty/claims" element={<ProtectedRoute><ClaimsList /></ProtectedRoute>} />
            <Route path="/admin/warranty/claims/:id" element={<ProtectedRoute><RmaCase /></ProtectedRoute>} />
            <Route path="/admin/vendor-claims" element={<ProtectedRoute><VendorClaims /></ProtectedRoute>} />
            <Route path="/admin/ready-to-ship" element={<ProtectedRoute><ReadyToShip /></ProtectedRoute>} />
            <Route path="/admin/shipping-batches/:id/slip" element={<ProtectedRoute><ShippingSlip /></ProtectedRoute>} />
            <Route path="/admin/replacements" element={<ProtectedRoute><Replacements /></ProtectedRoute>} />
            <Route path="/admin/replacements/:id/report" element={<ProtectedRoute><ReplacementReport /></ProtectedRoute>} />
            <Route path="/admin/credit-notes" element={<ProtectedRoute><CreditNotes /></ProtectedRoute>} />
            <Route path="/admin/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
            <Route path="/admin/suppliers" element={<ProtectedRoute><Suppliers /></ProtectedRoute>} />
            <Route path="/admin/sub-inventory" element={<ProtectedRoute><SubInventory /></ProtectedRoute>} />
            <Route path="/admin/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/warranty" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
